import Api from './rest/CrmLeadChangeApi';

export default new Api();
